import { render, staticRenderFns } from "./ItemsListGanttDiagram.vue?vue&type=template&id=06f88b79&scoped=true"
import script from "./ItemsListGanttDiagram.vue?vue&type=script&lang=ts"
export * from "./ItemsListGanttDiagram.vue?vue&type=script&lang=ts"
import style0 from "./ItemsListGanttDiagram.vue?vue&type=style&index=0&id=06f88b79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f88b79",
  null
  
)

export default component.exports